// 顶级状态

export const SET_DEBUG = 'SET_DEBUG'; // debug

export const SET_TITLE = 'SET_TITLE'; // 标题

export const SET_SHARE_WECHAT = 'SET_SHARE_WECHAT'; // 微信分享遮罩层

export const SET_VISIBLE_TOP = 'SET_VISIBLE_TOP'; // 顶部导航栏

export const SET_NAVIGATION_APP = 'SET_NAVIGATION_APP'; // 打开APP导航栏

export const SET_HIDE_TOP_ROUTERS = 'SET_HIDE_TOP_ROUTERS'; // 隐藏顶部导航栏路由

// =============  user userInfo 用户状态  =============

export const USER_USERINFO_CLEAR = 'USER_USERINFO_CLEAR'; // 用户信息清除

export const USER_USERINFO_UPDATE = 'USER_USERINFO_UPDATE'; // 用户信息更新

export const INVOICE_ROW_UPDATE = 'INVOICE_ROW_UPDATE'; // 发票选择更新
export const INVOICE_SELECT_IDS = 'INVOICE_SELECT_IDS'; //选中的发票id
export const UPDATE_CURRENT_TICKET = 'UPDATE_CURRENT_TICKET'; //发票详情
export const INVOICE_UPDATE_OPEN = 'INVOICE_UPDATE_OPEN'; //发票展开

// =============  signIn  =============
export const SIGNIN_CALENDAR_UPDATE = 'SIGNIN_CALENDAR_UPDATE'; // 更新日历
export const SIGNIN_CARD_COUNT_UPDATE = 'SIGNIN_CARD_COUNT_UPDATE'; // 更新补签卡数量
export const SIGNIN_SUPPLEMENT_CARD_EXCHANGE_UPDATE = 'SIGNIN_SUPPLEMENT_CARD_EXCHANGE_UPDATE'; // 更新补签卡数量
